import { useState } from "react";
import { Button } from "./ui/button";
import { api, errorMessage } from "../lib/api";

const OPTIONS = [["interested", "Interessato"], ["callback", "Richiamare"],
  ["no_answer", "Non risponde"], ["not_interested", "Non interessato"],
  ["not_target", "Non in target"]];
const REASONS = [["prezzo", "Prezzo"], ["ha già un gestionale", "Ha già un gestionale"],
  ["non ha tempo", "Non ha tempo"], ["non decide lui", "Non decide lui"], ["altro", "Altro"]];
const localTime = (date) => new Intl.DateTimeFormat("sv-SE", {
  timeZone: "Europe/Rome", year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit", hourCycle: "h23",
}).format(date).replace(" ", "T");

export const CallOutcomeForm = ({ venue, csrfToken, onBack, onSaved, onBook, callId, callAction, correction }) => {
  const [code, setCode] = useState(correction?.outcome_code || "");
  const [note, setNote] = useState(correction?.note || "");
  const [callbackAt, setCallbackAt] = useState("");
  const [reason, setReason] = useState(correction?.reason || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try {
      await api[callId ? "patch" : "post"](correction ? `/venues/${venue.id}/calls/${callId}/correction`
        : callId ? `/venues/${venue.id}/calls/${callId}` : `/venues/${venue.id}/calls`, {
        code, note: note.trim(), callback_at: code === "callback" ? callbackAt : null,
        reason: ["not_interested", "not_target"].includes(code) ? reason : null,
      }, { headers: { "X-CSRF-Token": csrfToken } });
      if (code === "interested") onBook(note.trim(), null);
      else onSaved();
    } catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  const chooseQuick = (days, hours) => {
    const future = new Date(Date.now() + days * 86_400_000 + hours * 3_600_000);
    setCallbackAt(localTime(future));
  };
  return <form className="outcome-form" onSubmit={submit} data-testid="call-outcome-form">
    <button className="sheet-back" type="button" onClick={onBack} data-testid="call-back-button">‹ Indietro</button>
    <h2 className="sheet-title" data-testid="call-outcome-title">{correction ? "Correggi l'esito" : "Com'è andata"} con {venue.name}?</h2>
    {callId && !correction && <p className="call-pending" role="status" data-testid="call-pending-status">Contatto registrato · esito da completare</p>}
    {callAction?.href && <a className="call-redial" href={callAction.href} target={callAction.type === "whatsapp" ? "_blank" : undefined}
      rel={callAction.type === "whatsapp" ? "noopener noreferrer" : undefined}
      data-testid="call-outcome-redial">{callAction.label} · {callAction.display}</a>}
    <div className="outcome-choices" role="group" aria-label="Esito del contatto" data-testid="call-outcome-choices">
      {OPTIONS.map(([key, label]) => <button key={key} type="button" className={code === key ? "active" : ""}
        aria-pressed={code === key} onClick={() => setCode(key)} data-testid={`call-outcome-${key.replaceAll("_", "-")}`}>{label}</button>)}
    </div>
    {code === "callback" && <><div className="outcome-choices" role="group" aria-label="Quando richiamare">
      {[["Oggi più tardi", 0, 3], ["Domani", 1, 0], ["Tra 3 giorni", 3, 0]].map(([label, days, hours]) =>
        <button type="button" key={label} disabled={days === 0 && localTime(new Date(Date.now() + 3 * 3_600_000)).slice(0, 10)
          !== localTime(new Date()).slice(0, 10)} onClick={() => chooseQuick(days, hours)}
          data-testid={`call-callback-${days}-${hours}`}>{label}</button>)}</div>
      <div className="form-field"><label htmlFor="call-callback-at">DATA E ORA</label>
        <input id="call-callback-at" type="datetime-local" min={localTime(new Date())}
          required value={callbackAt} onChange={(event) => setCallbackAt(event.target.value)}
          data-testid="call-callback-at" /></div></>}
    {["not_interested", "not_target"].includes(code) && <div className="form-field"><label htmlFor="call-reason">MOTIVO</label>
      <select id="call-reason" required value={reason} onChange={(event) => setReason(event.target.value)}
        data-testid="call-reason-select"><option value="">Seleziona</option>{REASONS.map(([key, label]) =>
        <option key={key} value={key}>{label}</option>)}</select></div>}
    <div className="form-field"><label htmlFor="call-note">NOTA</label><textarea id="call-note" required
      minLength={1} maxLength={2000} className="hud-textarea" value={note} onChange={(e) => setNote(e.target.value)}
      data-testid="call-note-input" /></div>
    {error && <p className="form-error" role="alert" data-testid="call-outcome-error">{error}</p>}
    <Button className="hud-button" type="submit" disabled={busy || !code || !note.trim() ||
      (code === "callback" && !callbackAt) || (["not_interested", "not_target"].includes(code) && !reason)}
      data-testid="call-save-button">{busy ? "Salvataggio…" : code === "interested" ? "Salva e fissa" : "Salva esito"}</Button>
  </form>;
};